// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSignupButton_root__wa5pD","text":"PlasmicSignupButton_text__ZWL3v"};